import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { FaRegCopy } from 'react-icons/fa'
import { FaShareNodes } from 'react-icons/fa6';
import { facebooksendmessage } from '../../../store/facebook/facebookThunk';
import { useDispatch, useSelector } from 'react-redux';
import { Oval } from 'react-loader-spinner';
import { instagramsendmessage } from '../../../store/instagram/instagramThunk';
import { sendWpMessage } from '../../../store/whatsApp/wpThunks';

const MeetModel = ({ show6, handleClose6, senderId, link,  platform }) => {
      const { generateMeetingLodading } = useSelector((state) => state.google);
    let dispatch = useDispatch();
    const handleSendMessage = async () => {
        if (platform === "facebook") {
            try {
                const data = {
                    messaging_type: "MESSAGE_TAG",
                    recipient: { id: senderId },
                    message: { text: link },
                    tag: "POST_PURCHASE_UPDATE",
                };
                await dispatch(facebooksendmessage(data));
            } catch (error) {
                console.log(error)
            }
        } else if (platform === "instagram") {
            try {
                alert("instagram")
                const data = {
                    recipient: { id: senderId },
                    message: { text: link },
                };
                await dispatch(instagramsendmessage(data));
            } catch (error) {
                console.log(error)
            }
        } else if (platform === "whatsapp") {
            alert("whatsapp")
            try {
                const data = {
                    messaging_product: "whatsapp",
                    to: senderId,
                    type: "text",
                    text: {
                        body: link
                    }
                }
                await dispatch(sendWpMessage(data));
            } catch (error) {
                console.log(error)
            }
        }
    }
    return (
        <div>
            <Modal centered show={show6} onHide={handleClose6}>
                <Modal.Header closeButton>
                    <Modal.Title className='h5'>Generated Meeting Link </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        !generateMeetingLodading ?
                            <>
                                <div className='d-flex '>
                                    <input
                                        type="text"
                                        value={link}
                                        readOnly
                                        className="form-control border-0 bg-transparent"
                                    />
                                    <button
                                        type="submit"
                                        className="btn btn-primary d-flex align-items-center"
                                    >
                                        <svg
                                            className="icon-20"
                                            width="18"
                                            viewBox="0 0 20 21"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M13.8325 6.67463L8.10904 12.4592L1.59944 8.38767C0.66675 7.80414 0.860765 6.38744 1.91572 6.07893L17.3712 1.55277C18.3373 1.26963 19.2326 2.17283 18.9456 3.142L14.3731 18.5868C14.0598 19.6432 12.6512 19.832 12.0732 18.8953L8.10601 12.4602"
                                                stroke="currentcolor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            ></path>
                                        </svg>
                                        <span className="d-none d-lg-block ms-1" onClick={handleSendMessage}>Send</span>
                                    </button>
                                </div>
                            </> : <Oval
                                height={30}
                                width={30}
                                color="#50B5FF"
                                secondaryColor="#ccc"
                                strokeWidth={4}
                                strokeWidthSecondary={2}
                                ariaLabel="loading"
                            />
                    }
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default MeetModel



